function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("g", {
  id: "Social_Media_Small_Dark_Twitter-2",
  "data-name": "Social Media / Small / Dark / Twitter",
  transform: "translate(0 0)"
}, /*#__PURE__*/React.createElement("path", {
  id: "Combined_Shape",
  "data-name": "Combined Shape",
  d: "M16.383,32.765A16.383,16.383,0,1,1,32.765,16.383,16.4,16.4,0,0,1,16.383,32.765ZM8.252,23.652v0a11.092,11.092,0,0,0,6,1.758,10.675,10.675,0,0,0,8.272-3.63,11.526,11.526,0,0,0,2.87-7.512c0-.183,0-.348-.01-.506a7.935,7.935,0,0,0,1.954-2.027,7.8,7.8,0,0,1-2.25.616,3.919,3.919,0,0,0,1.723-2.167,7.8,7.8,0,0,1-2.487.95,3.919,3.919,0,0,0-6.775,2.68,3.854,3.854,0,0,0,.1.892,11.156,11.156,0,0,1-8.072-4.093,3.921,3.921,0,0,0,1.212,5.229,3.915,3.915,0,0,1-1.773-.49V15.4a3.928,3.928,0,0,0,3.141,3.84,3.948,3.948,0,0,1-1.769.067,3.916,3.916,0,0,0,3.659,2.719,7.9,7.9,0,0,1-5.8,1.622Z",
  fill: "#fff"
}));

var SvgTwitter = function SvgTwitter(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Social_Media_Small_Dark_Twitter",
    "data-name": "Social Media / Small / Dark / Twitter",
    width: 33,
    height: 33,
    viewBox: "0 0 33 33",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgTwitter, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/Twitter.cc107e6d.svg";
export { ForwardRef as ReactComponent };